import { render, staticRenderFns } from "./article.vue?vue&type=template&id=18b9550e&scoped=true&"
import script from "./article.vue?vue&type=script&lang=js&"
export * from "./article.vue?vue&type=script&lang=js&"
import style0 from "./article.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./article.vue?vue&type=style&index=1&id=18b9550e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b9550e",
  null
  
)

export default component.exports